<template>
  <div>
    <h1>Artist's Campaigns</h1>
    <ArtistCampaigns/>
  </div>
</template>

<script>
import ArtistCampaigns from '@/modules/artist/my-vidcents/views/Index'

export default {

  components: {
    ArtistCampaigns
  },
}
</script>